import React from "react";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {HashRouter as IOSRouter} from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useDispatch, useSelector } from "react-redux";

import history from "./History";
import { WithMenuRoute, WithMenuRoutePrivate } from "./WithMenuRoute";
import {
  URL_LEGAL,
  URL_HOME,
  URL_REGISTER,
  URL_LOGIN,
  URL_SELECTLOGIN,
  URL_SEARCH,
  URL_BUSCAR,
  URL_AGENDA,
  URL_CATALOGUE,
  URL_CONTENT,
  URL_PROFILE,
  URL_RANKING,
  URL_PUBLIC_RANKING,
  URL_PLAYER,
  URL_VIDEODETAIL,
  URL_DETAIL,
  URL_PUBLISH,
  URL_NAME_PUBLISH,
  URL_REJECT,
  URL_NAME_REJECT,
  URL_PRODUCTS,
  URL_SUCCESS_CHECKOUT,
  URL_CANCEL_CHECKOUT,
  URL_DISCOVER,
  URL_EPG,
  URL_INDEX,
  URL_SECTION,
  URL_SCREEN,
} from "./Location";
import BuscarPage from "../../../../search/src/Pages/Buscar/BuscarPage";
import AgendaPage from "../../../../search/src/Pages/Agenda/AgendaPage";
import Ranking from "../../../../user/src/Pages/Usuario/Ranking";
import PublicRankingListPage from "../../../../user/src/Pages/Usuario/PublicRankingListPage";
import UserProfile from "../../../../user/src/Pages/Usuario/UserProfile";
import { GlobalLoadingComponent } from "../Loader/GlobalLoadingComponent";
import ExpiredSessionModalComponent from "../common/ExpiredSessionModalComponent";
import ProductsComponent from "../../../../products/src/Pages/Products/ProductsComponent";
import CheckoutComponent from "../../../../checkout/src/Pages/Checkout/CheckoutComponent";
import PublishRejectComponent from "../../../../publish/src/Pages/publish/PublishRejectComponent";
import VideoDetailPage from "../../../../detail/src/Pages/DetailPage/VideoDetailPage";
import DetailPage from "../../../../detail/src/Pages/DetailPage/DetailPage";
import PlayerPage from "../../../../player/src/Pages/Player/PlayerPage";
import EPGPage from "../../../../epg/src/Pages/EPG/EPGPage";
import SectionComponent from "../../../../catalogue/src/Pages/Section/SectionComponent";
import Content from "../../../../catalogue/src/Pages/Content/Content";
import Legal from "../../../../user/src/Pages/Legal/Legal";
import HomeComponent from "../../../../home/src/Pages/Home/HomeComponent";
import Register from "../../../../user/src/Pages/Register/Register";
import SelectAge from "../../../../user/src/Pages/SelectAge/SelectAge";
import App from "../../App";
import { useState } from "react";
import LoginRegisterRecoverForm from "../../Pages/LoginRegisterRecoverForm/LoginRegisterRecoverForm";
import { getTokensFromSecureStorage, initSecureStorage, isCordovaAvailable } from "../../Utils/secureStorageUtil";
import { initializeKeycloak } from "../../Utils/keycloak";
import { turnOffLoadingActionCreator, userLoginActionCreator } from "../../actions/commonActions";
import { useEffect } from "react";

const getPlatformRouter = () => {
  if (isCordovaAvailable() && window.device?.platform) {
    const platform = window.device.platform.toLowerCase();
    if (platform === 'ios') {
      return IOSRouter;
    }
  }
  return Router;
};

const Routes = ({ changekeycloak }) => {
  const { keycloak, initialized } = useKeycloak();
  const dispatch = useDispatch();
  const [scrollRef, setScrollRef] = useState(null);
  const [isGuest, setIsGuest] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCheckingForCredentials, setIsCheckingForCredentials] = useState(isCordovaAvailable());
  const sessionExpiredModal = useSelector((state) => state.commonState.isSessionExpired);

  const loading = useSelector((state) => state.commonState.loading);

  const PlatformRouter = getPlatformRouter();

  const getStoredCredentialsFallback = () => {
    const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token") || sessionStorage.getItem("refresh_token");
    const username = localStorage.getItem("username") || sessionStorage.getItem("username");
    if (token && refreshToken && username) {
      return { token, refreshToken, username };
    }
    return null;
  };

  const checkForTokensInSecureStorage = () => {
    getTokensFromSecureStorage().then(({ token, refreshToken, username }) => {
      initializeKeycloak(token, refreshToken, username);
      dispatch(userLoginActionCreator(username));
      setIsLoggedIn(true);
      setIsCheckingForCredentials(false);
      dispatch(turnOffLoadingActionCreator());
    })
    .catch((error) => {
      const fallbackCredentials = getStoredCredentialsFallback();
      if (fallbackCredentials) {
        const { token, refreshToken, username } = fallbackCredentials;
        initializeKeycloak(token, refreshToken, username);
        dispatch(userLoginActionCreator(username));
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
      setIsCheckingForCredentials(false);
      dispatch(turnOffLoadingActionCreator());
    });
  }

  useEffect(() => {
    if ((!!keycloak && !!initialized) || isCordovaAvailable()) {
      if (isCordovaAvailable()) {
        initSecureStorage(
          () => {checkForTokensInSecureStorage()},
          (error) => {
            const fallbackCredentials = getStoredCredentialsFallback();
            if (fallbackCredentials) {
              const { token, refreshToken, username } = fallbackCredentials;
              initializeKeycloak(token, refreshToken, username);
              dispatch(userLoginActionCreator(username));
              setIsLoggedIn(true);
            } else {
              setIsLoggedIn(false);
            }
            setIsCheckingForCredentials(false);
            dispatch(turnOffLoadingActionCreator())
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak, initialized])

  if ((!initialized || !keycloak.clientId) && !isCordovaAvailable()) {
    return null;
  }

  const handleNavigateAsGuest = () => {
    setIsGuest(true);
  }

  const renderLoginOrHomeComponent = (props) => {
    if (isCordovaAvailable()) {
      if (isCheckingForCredentials) {
        return <></>;
      } else if (!isLoggedIn) {
        return <LoginRegisterRecoverForm handleNavigateAsGuest={handleNavigateAsGuest} {...props} />;
      }
    }
    return <HomeComponent {...props} scrollRef={scrollRef} isGuest={isGuest} />;
  };

  return (
    <PlatformRouter history={history}>
      <App className="loader" setScrollRef={setScrollRef}>
        <Switch>
          <Route path={`*${URL_REGISTER}`} component={Register} />
          <Route path={`${URL_LOGIN}${URL_HOME}`} render={(props) => <Legal {...props} />} />
          <Route path={`${URL_LEGAL}${URL_LOGIN}${URL_HOME}`} render={(props) => <HomeComponent {...props} scrollRef={scrollRef} />} />
          <Route exact path={`*${URL_HOME}`} render={(props) => <HomeComponent {...props} scrollRef={scrollRef} />} />
          <Route exact path={`${URL_SCREEN}/:screenName/:screenId`} render={(props) => <HomeComponent {...props} scrollRef={scrollRef} />} />
          <Route path={URL_LEGAL} component={Legal} />
          {/*<Route path={URL_ERRORPAGE} component={ErrorPage} />*/}
          <Route path={`${URL_PUBLISH}/:contentId`} render={() => <PublishRejectComponent event={URL_NAME_PUBLISH} />} />
          <Route path={`${URL_REJECT}/:contentId`} render={() => <PublishRejectComponent event={URL_NAME_REJECT} />} />
          <Route path={URL_SELECTLOGIN} render={(props) => <SelectAge changekeycloak={changekeycloak} {...props} />} />
          <Route
              path={URL_LOGIN}
              render={(props) => {
                if (isCordovaAvailable()) {
                  // Si Cordova está disponible, muestra el formulario de login
                  return <LoginRegisterRecoverForm handleNavigateAsGuest={handleNavigateAsGuest} {...props} />;
                } else {
                  // Si Cordova no está disponible, redirige a /HOME
                  return <Redirect to={`${URL_HOME}`} />;
                }
              }}
          />;
          {/*Paxinas internas*/}
          {/* OTT-1966 Fase 4: Descubre y el buscador antiguo se retiran; sus rutas redirigen a /buscar. */}
          <WithMenuRoute exact path={URL_EPG} component={EPGPage} scrollRef={scrollRef} />
          <WithMenuRoute path={`${URL_SECTION}/:sectionName`} component={SectionComponent} scrollRef={scrollRef} />
          <Route path={URL_SEARCH} render={({ location }) => <Redirect to={{ pathname: URL_BUSCAR, search: location.search }} />} />
          <WithMenuRoute path={URL_BUSCAR} component={BuscarPage} scrollRef={scrollRef} />
          <WithMenuRoute path={URL_AGENDA} component={AgendaPage} scrollRef={scrollRef} />
          <Redirect exact from={URL_DISCOVER} to={URL_BUSCAR} />
          <Redirect from={URL_CATALOGUE} to={URL_BUSCAR} />
          <WithMenuRoute path={`${URL_CONTENT}/:type/:id`} component={Content} noScroll={true}  scrollRef={scrollRef} />
          <WithMenuRoute path={`${URL_PLAYER}/:id`} component={PlayerPage} nofooter={true} scrollRef={scrollRef} />
          <WithMenuRoute path={`${URL_VIDEODETAIL}/:id/:slug?`} component={VideoDetailPage} scrollRef={scrollRef} />
          <WithMenuRoute path={`${URL_DETAIL}/:id/:slug?`} component={DetailPage} scrollRef={scrollRef} />
          <WithMenuRoute path={`${URL_PRODUCTS}/:id`} component={ProductsComponent} />
          <WithMenuRoute path={`${URL_SUCCESS_CHECKOUT}/:id`} component={CheckoutComponent} success={true} />
          <WithMenuRoute path={`${URL_CANCEL_CHECKOUT}/:id`} component={CheckoutComponent} success={false} />
          <WithMenuRoute path={URL_PUBLIC_RANKING} component={PublicRankingListPage} />
          <WithMenuRoutePrivate path={URL_RANKING} component={Ranking} />
          <WithMenuRoutePrivate path={URL_PROFILE} component={UserProfile} scrollRef={scrollRef} />
          <Route path={URL_INDEX} render={renderLoginOrHomeComponent} />
        </Switch>
        {loading && <GlobalLoadingComponent />}
        {sessionExpiredModal && <ExpiredSessionModalComponent />}
      </App>
    </PlatformRouter>
  );
};

export default Routes;
